import { render, staticRenderFns } from "./TheDynamicNavHeaders.vue?vue&type=template&id=12f0c2be"
import script from "./TheDynamicNavHeaders.vue?vue&type=script&lang=js"
export * from "./TheDynamicNavHeaders.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports